import React from "react";
import { Button } from "@mui/material";
import useVideoContext from "../../../../hooks/useVideoContext/useVideoContext";
import { semanticColors } from "../../../../utils/colors";
import { typography } from "../../../../utils/typography";

export default function EndCallButton(props: { className?: string }) {
  const { room } = useVideoContext();

  return (
    <Button
      onClick={() => room!.disconnect()}
      className={props.className}
      data-cy-disconnect
      sx={{
        ...typography.body.lBold,
        background: semanticColors.feedback.danger,
        color: semanticColors.text.inverse,
        textTransform: "none",
        borderRadius: "40px",
        px: "24px",
        height: "40px",
        "&:hover": {
          background: "#C4002A"
        }
      }}
    >
      Desligar
    </Button>
  );
}
